var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home" }, [
    _c("ul", { staticClass: "flexContent flex" }, [
      _c("li", { staticClass: "leftData flex flex-column" }, [
        _c(
          "div",
          { staticClass: "takeNumber bk_b" },
          [
            _c(
              "dv-border-box-10",
              [_c("roomsTop", { attrs: { roleType: "0" } })],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "sosAlarm bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("takeCharge", { attrs: { roleType: "0" } })],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "sosAlarm bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("takeChargeLongTime", { attrs: { roleType: "0" } })],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("li", { staticClass: "eachartsCont flex flex-column flex-1" }, [
        _c(
          "div",
          { staticClass: "mapChart" },
          [_c("chinaMap", { attrs: { showType: "1" } })],
          1
        ),
        _c(
          "div",
          { staticClass: "bar_charts" },
          [_c("barCharts", { attrs: { showType: "1" } })],
          1
        ),
      ]),
      _c("li", { staticClass: "rightData flex flex-column" }, [
        _c(
          "div",
          { staticClass: "right_top1 bk_b" },
          [
            _c(
              "dv-border-box-10",
              [_c("roomsNum", { attrs: { roleType: "0" } })],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right_2 bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("enterDetails", { staticClass: "listPd" })],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right_3 bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("checkInTime", { attrs: { roleType: "0" } })],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }